import type { IconSvgObject } from './types';

const PillOffIcon: IconSvgObject = [
  ["path", { d: "M10.5 6.5L12.5503 4.44975C13.4785 3.52149 14.7375 3 16.0503 3C18.7839 3 21 5.21608 21 7.94975C21 9.2625 20.4785 10.5215 19.5503 11.4497L17.5 13.5M8.5 8.5L4.44975 12.5503C3.52149 13.4785 3 14.7375 3 16.0503C3 18.7839 5.21608 21 7.94975 21C9.2625 21 10.5215 20.4785 11.4497 19.5503L15.5 15.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M3 3L21 21", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default PillOffIcon;
